<template>
  <div class="header">
    <b-link :href="$store.state.LocalURL">
      <NomeSito style="float:left" />
      <div style="float: right">
        <br />
        <Lingua></Lingua>
      </div>
      <span style="float:right;margin-top:10px;margin-right:12px;cursor: default;color: black;font-size:smaller" @click.capture.stop.prevent="clickwindow">
        <br />
        {{ $store.state.Utente }}
      </span>
      <div style="clear:both"></div>
    </b-link>
  </div>
</template>

<script>
import NomeSito from "@/components/NomeSito";
import Lingua from "@/components/Lingua";

export default {
  name: "Header",
  components: {
    NomeSito,
    Lingua
  },
  data() {
    return {
      lingua: "",
      lingue: [
        { value: "IT", text: "Italiano" },
        { value: "EN", text: "English" },
        { value: "DE", text: "Deutsch" }
        //{ value: "FR", text: "Français }
      ]
    };
  },
  props: {},
  watch: {
    "$store.state.Lingua"(Lingua) {
      this.lingua = Lingua;
    }
  },
  methods: {
    CambiaLingua() {
      this.$store.commit("SettaLingua", this.lingua);
    },
    clickwindow(){}
  },
  created() {
    this.lingua = this.$store.state.Lingua;

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  height: auto;
  padding: 5px;
}
</style>
